import { EcmNodeContent } from "../../model/EcmNodeContent";
import { MessageResponse } from "../../model/MessageResponse";
import { repositorySign } from "../_const/_constVar";
import Repository from "../helper/HttpHelper";
import { NotificationExtension } from "./NotificationExtension";
import { format, toZonedTime } from "date-fns-tz";

const timeZone = "Asia/Ho_Chi_Minh";
export const GUID = () => {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
};

export function isValidEmail(email: string) {
  const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;
  return regex.test(email);
}
export interface UploadFileResult {
  etag: string;
  objectName: string;
  pathNameBefore: string;
  size: number;
  endPoint: string;
  bucket: string;
  url: string; // Để phù hợp với Uri trong C#
  fileNameBeforeUpdate?: string;
}

export async function uploadFile(files: Array<File>) {
  if (!files || files.length < 1) {
    NotificationExtension.Fails("Danh sách file rỗng !");
    return;
  }
  const formData = new FormData();
  for (let index = 0; index < files.length; index++) {
    const element = files[index];
    formData.append("files", element);
  }
  try {
    // const repositorySign1 = new Repository("http://localhost:5004");

    const response = await repositorySign.post<
      MessageResponse<Array<UploadFileResult>>
    >("/api/v1/Upload/files-v2", formData);

    if (response?.success === true) {
      // NotificationExtension.Success("Thêm tệp tin thành công");
      return response.data;
    } else {
      // NotificationExtension.Fails("Thêm tệp tin thất bại");
    }
  } catch (error) {
    console.error("Error uploading files:", error);
  }
  return null;
}

export async function getFileNames(filesUrl: Array<string> | string): Promise<Array<EcmNodeContent> | undefined> {
  if (!filesUrl || filesUrl.length < 1) {
    NotificationExtension.Fails("Danh sách file rỗng !");
    return;
  }
  try {
    let urlFile = Array.isArray(filesUrl)
      ? filesUrl
      : filesUrl
      ? filesUrl.split("||")
      : [];
    urlFile = urlFile
      .map((x) => {
        const handlerFIle = x.split("/").pop();
        return handlerFIle;
      })
      .filter((x): x is string => x !== undefined);
    if (urlFile.length < 1) return;
    const url = `/api/v1/upload/files-name`;
    const response = await repositorySign.post<
      MessageResponse<EcmNodeContent[]>
    >(url, urlFile);
    if (response?.httpStatusCode === 200)
      if (response && response.success) {
        return response.data || [];
      }
  } catch (error) {
    console.error("Error uploading files:", error);
  }
  return undefined;
}
